import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import COLORS from '../../../../resources/style/Themes';

export default function EditAppInboxModal({ show, onHide, message, onSave }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [url, setUrl] = useState('');
  const [id, setId] = useState('');
  const [languageCode, setLanguageCode] = useState('');
  const [name, setName] = useState('');

  useEffect(() => {
    if (message) {
      setTitle(message.header);
      setContent(message.message);
      setName(message.name);
      setUrl(message.url || '');
      setId(message.id);
      setLanguageCode(message.language_code);
    }
  }, [message]);

  const handleSave = () => {
    const updatedMessage = {
      header: title,
      name: name,
      message: content,
      language_code: languageCode,
      url: url,
      id: id,
    };
    onSave(updatedMessage);
    setTitle('');
    setContent('');
    setId('');
    setName('');
    setUrl('');
    onHide();
  };

  return (
    <Dialog open={show} onClose={onHide} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{ background: COLORS.SAFEGUARD_BLUE, color: COLORS.WHITE }}
      >
        Edit {title}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Message"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          fullWidth
          margin="normal"
          label="URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
          <Select
            value={languageCode}
            onChange={(e) => setLanguageCode(e.target.value)}
            displayEmpty
            inputProps={{ 'aria-label': 'Language Code' }}
          >
            <MenuItem value="" disabled>
              Select Language Code
            </MenuItem>
            <MenuItem value="dan">Danish</MenuItem>
            <MenuItem value="eng">English</MenuItem>
            <MenuItem value="fin">Finnish</MenuItem>
            <MenuItem value="fra">French</MenuItem>
            <MenuItem value="deu">German</MenuItem>
            <MenuItem value="ell">Greek</MenuItem>
            <MenuItem value="nob">Norwegian</MenuItem>
            <MenuItem value="pol">Polish</MenuItem>
            <MenuItem value="por">Portuguese</MenuItem>
            <MenuItem value="spa">Spanish</MenuItem>
            <MenuItem value="swe">Swedish</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSave}
          sx={{
            backgroundColor: COLORS.SAFEGUARD_ORANGE,
            color: COLORS.WHITE,
            '&:hover': {
              backgroundColor: COLORS.SAFEGUARD_ORANGE,
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
